// extracted by mini-css-extract-plugin
export var FullWidthBanner = "FullWidthContent-module--FullWidthBanner--8mJCs";
export var DarkMode = "FullWidthContent-module--DarkMode--jnhc5";
export var ContentTitle = "FullWidthContent-module--ContentTitle--uOW4t";
export var ButtonWrapper = "FullWidthContent-module--ButtonWrapper--UBarP";
export var Container = "FullWidthContent-module--Container--11DA4";
export var Content = "FullWidthContent-module--Content--c3kH7";
export var ContentImageWrapper = "FullWidthContent-module--ContentImageWrapper--GRuG8";
export var ContentImage = "FullWidthContent-module--ContentImage--MAmop";
export var AlignLeft = "FullWidthContent-module--AlignLeft--fRE1v";